export const cloneOrder = (orderObjectId: string) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderObjectId}/clone`,
  }
}
